import { StorefrontIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PortalItem = ({ portal }) => {
  const theme = useTheme()
  const logoUrl = portal.theme?.returns_favicon_url || portal.theme?.logo_url

  return (
    <Styles.Container>
      <Styles.NameAndLogoContainer>
        {logoUrl ? (
          <Styles.Logo src={logoUrl} alt={portal.internal_name} />
        ) : (
          <StorefrontIcon size={24} color={theme.colors.text.subtle} />
        )}
        <Text type="bodyMRegular">{portal.internal_name}</Text>
      </Styles.NameAndLogoContainer>
      <Text type="bodyXSRegular">{portal.store?.domain}</Text>
    </Styles.Container>
  )
}

export default PortalItem
